import React from 'react';

import Default from '@common/blocks/list/Default';
import Tabs from '@common/blocks/list/tabs/Tabs';
import Accordion from '@common/blocks/list/accordion/Accordion';
import BorderAccordion from '@common/blocks/list/border-accordion/BorderAccordion';
import ReviewsList from '@common/blocks/list/reviews-list/ReviewsList';
import ReviewsSlider from '@common/blocks/list/reviews-slider/ReviewsSlider';
import ReviewsSliderImage from '@common/blocks/list/reviews-slider-image/ReviewsSliderImage';
import ReviewsSliderWithFilter from '@common/blocks/list/reviews-slider-with-filter/ReviewsSliderWithFilter';
import ResourceCards from '@common/blocks/list/resource-cards/ResourceCards';
import ResourceList from '@common/blocks/list/resource-list/ResourceList';
import TextHighlight from '@common/blocks/list/text-highlight/TextHighlight';
import UsersEmployeeCards from '@common/blocks/list/users-employee-cards/UsersEmployeeCards';
import UsersAffirmations from '@common/blocks/list/users-affirmations/UsersAffirmations';
import UsersLeadershipCards from '@common/blocks/list/users-leadership-cards/UsersLeadershipCards';
import UsersSpeakers from '@common/blocks/list/users-speakers/UsersSpeakers';
import GridLinks from '@common/blocks/list/grid-links/GridLinks';
import TemplateDownloads from '@common/blocks/list/template-downloads/TemplateDownloads';
import DownloadCards from '@common/blocks/list/download-cards/DownloadCards';
import TextCurriculumProducts from '@common/blocks/list/text-curriculum-products/TextCurriculumProducts';
import ColouredTextBlocks from '@common/blocks/list/coloured-text-blocks/ColouredTextBlocks';
import SlidesFilterBySolution from '@common/blocks/list/slides-filter-by-solution/SlidesFilterBySolution';
import SlidesFilterBySize from '@common/blocks/list/slides-filter-by-size/SlidesFilterBySize';
import BundlesAndProducts from '@common/blocks/list/bundles-and-products/BundlesAndProducts';
import BorderedLinks from '@common/blocks/list/bordered-links/BorderedLinks';
import LinksCourses from '@common/blocks/list/links-courses/LinksCourses';
import LinksPress from '@common/blocks/list/links-press/LinksPress';
import LinksFeatures from '@common/blocks/list/links-features/LinksFeatures';
import LinksCarousel from '@common/blocks/list/links-carousel/LinksCarousel';
import LinksRotatingBackground from '@common/blocks/list/links-rotating-background/LinksRotatingBackground';
import AboutLinkBorder from '@common/blocks/list/about-link-border/AboutLinkBorder';
import FlexSlider from '@common/blocks/list/flex-slider/FlexSlider';
import FlexSolutionsGrid from '@common/blocks/list/flex-solutions-grid/FlexSolutionsGrid';
import EventSessionCards from '@common/blocks/list/event-session-cards/EventSessionCards';
import EventSummitAgenda from '@common/blocks/list/event-summit-agenda/EventSummitAgenda';
import EventSummitSessions from '@common/blocks/list/event-summit-sessions/EventSummitSessions';
import TextContactCards from '@common/blocks/list/text-contact-cards/TextContactCards';
import TextBorderedBoxes from '@common/blocks/list/text-bordered-boxes/TextBorderedBoxes';
import TextColoredBoxes from '@common/blocks/list/text-colored-boxes/TextColoredBoxes';
import TextSummitHighlights from '@common/blocks/list/text-summit-highlights/TextSummitHighlights';
import TextFAQ from '@common/blocks/list/text-faq/TextFAQ';

const components = [
  {
    component: Default,
    key: 'Default'
  },
  {
    component: Accordion,
    key: 'Accordion'
  },
  {
    component: BorderAccordion,
    key: 'Border Accordion'
  },
  {
    component: Tabs,
    key: 'Tabs'
  },
  {
    component: ReviewsList,
    key: 'Reviews - List'
  },
  {
    component: ReviewsSlider,
    key: 'Reviews - Slider Full Width'
  },
  {
    component: ReviewsSliderImage,
    key: 'Reviews - Slider Image'
  },
  {
    component: ReviewsSliderWithFilter,
    key: 'Reviews - Slider with Filter'
  },
  {
    component: ResourceCards,
    key: 'Resource Cards'
  },
  {
    component: ResourceList,
    key: 'Resource List'
  },
  {
    component: TextHighlight,
    key: 'Text Highlight'
  },
  {
    component: TextContactCards,
    key: 'Text - Contact Cards'
  },
  {
    component: TextSummitHighlights,
    key: 'Text - Summit Highlights'
  },
  {
    component: TextFAQ,
    key: 'Text - FAQ'
  },
  {
    component: UsersEmployeeCards,
    key: 'Users - Employee Cards'
  },
  {
    component: UsersAffirmations,
    key: 'Users - Affirmations'
  },
  {
    component: UsersLeadershipCards,
    key: 'Users - Leadership Cards'
  },
  {
    component: UsersSpeakers,
    key: 'Users - Speakers'
  },
  {
    component: GridLinks,
    key: 'Grid Links'
  },
  {
    component: BorderedLinks,
    key: 'Bordered Links'
  },
  {
    component: TemplateDownloads,
    key: 'Template Downloads'
  },
  {
    component: TextCurriculumProducts,
    key: 'Text - Curriculum Products'
  },
  {
    component: ColouredTextBlocks,
    key: 'Coloured Text Blocks'
  },
  {
    component: SlidesFilterBySolution,
    key: 'Customer Story - Filter by solution'
  },
  {
    component: SlidesFilterBySize,
    key: 'Customer Story - Filter by size'
  },
  {
    component: BundlesAndProducts,
    key: 'Bundles and Products'
  },
  {
    component: DownloadCards,
    key: 'Download Cards'
  },
  {
    component: LinksCourses,
    key: 'Links - Courses'
  },
  {
    component: LinksPress,
    key: 'Links - Press'
  },
  {
    component: LinksFeatures,
    key: 'Links - Features'
  },
  {
    component: LinksCarousel,
    key: 'Links - Carousel'
  },
  {
    component: LinksRotatingBackground,
    key: 'Links - Rotating Background'
  },
  {
    component: AboutLinkBorder,
    key: 'About - Link Border'
  },
  {
    component: FlexSlider,
    key: 'Flex - Slider'
  },
  {
    component: FlexSolutionsGrid,
    key: 'Flex - Solutions Grid'
  },
  {
    component: EventSessionCards,
    key: 'Event - Session Cards'
  },
  {
    component: EventSummitAgenda,
    key: 'Event - Summit Agenda'
  },
  {
    component: EventSummitSessions,
    key: 'Event - Summit Sessions'
  },
  {
    component: TextBorderedBoxes,
    key: 'Text - Bordered Boxes'
  },
  {
    component: TextColoredBoxes,
    key: 'Text - Colored Boxes'
  }
];

const ListBlock = ({ data }) => {
  const { style } = data;
  const Component = components.find(x => x.key === style)?.component || Default;
  return <Component data={data}/>;
}

export default ListBlock
